import omit from 'lodash/omit'

import {
  GetUserProfileQuery,
  GetUserProfileQueryVariables,
  useGetUserProfileQuery,
  UserProfileInput,
  useUpdateUserProfileMutation
} from '@app/data'
import { QueryHookOptions } from '@app/data/graphqlHooks'
import { LogUtils } from '@app/utils/LogUtils'

export const useUserProfile = (baseOptions?: QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) => {
  const getStudentDetailData = useGetUserProfileQuery({
    ...baseOptions
  })
  const { data, ...restOfResult } = getStudentDetailData

  const [updateUserProfileMutation, updateUserProfileMutationData] = useUpdateUserProfileMutation()

  const updateProfile = async (newUserProfile: UserProfileInput) => {
    const userProfile: UserProfileInput = omit(newUserProfile, ['__typename', 'id', 'pictureUrl', 'username'])

    try {
      await updateUserProfileMutation({
        variables: { userProfile }
      })
    } catch (err) {
      LogUtils.logError(err, 'useUserProfile', 'updateProfile')
    }
  }

  return {
    data: data?.userProfile,
    isPending: updateUserProfileMutationData.loading,
    ...restOfResult,
    actions: {
      updateProfile
    }
  }
}
